import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 📊 Optional: Log vitals in development
reportWebVitals(console.log); // 👈 Shows performance metrics in DevTools

// 📦 For production: Uncomment below and add your own analytics handler
// reportWebVitals((metric) => {
//   console.log(metric);
// });